<template>
  <a-modal v-model="visible" title="" :footer="null" width="700px" :bodyStyle="{ minHeight: '300px' }" @cancel="closeModal(options.evalError)">
    <div class="modal-container">
      <a-divider orientation="left"><h2>匹配成绩</h2></a-divider>
      <template v-if="!options.evalError">
        <div class="upload-success">
          <h2 class="upload-success-title">匹配成功！</h2>
          <div :class="item.matchCount<30?'upload-error-desc':'upload-success-desc'" v-for="(item, index) in options.matchData" :key="index">
            <template v-if="item.matchCount >= 30">
              {{ item.gradeName }}：匹配学生为{{ item.matchCount }}人，满足潜力分析条件。
            </template>
            <template v-else>
              {{ item.gradeName }}：匹配学生为{{ item.matchCount }}人，小于30人，不满足潜力分析条件。
            </template>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="upload-error">
          <h2 class="upload-error-title">匹配失败！</h2>
          <div class="upload-error-desc">{{ options.matchErrorMsg }}</div>
        </div>
      </template>
      <div class="upload-bottom">
        <a-button type="primary" @click="closeModal(options.evalError)">确定</a-button>
      </div>
    </div>
  </a-modal>
</template>
<script>
export default {
  name: 'UploadStudent',
  data() {
    return {
      visible: false,
      options: {
        matchData: [],
        matchErrorMsg: undefined,
      },
    }
  },
  methods: {
    showModal(options = {}) {
      return new Promise((resolve, reject) => {
        this._resolve = resolve
        this._reject = reject
        this.visible = true
        this.options = options
      })
    },
    closeModal(reject, params) {
      reject ? this._reject(params) : this._resolve(params)
      this.visible = false
    },
  },
}
</script>
<style lang="less" scoped>
.error-data {
  color: red;
  cursor: pointer;
  margin-top: 10px;
}
.upload-error {
  text-align: center;
  padding: 20px 80px;
}
.upload-error-title {
  color: red;
}
.upload-success-title {
  color: var(--color);
  text-align: center;
}
.upload-error-desc {
  color: red;
  font-size: 16px;
  padding-left: 40px;
}
.upload-success-desc {
  color: var(--color);
  font-size: 16px;
    padding-left: 40px;
}
.upload-bottom {
  text-align: center;
  margin-top: 30px;
}
</style>
